import { Picture } from 'components/Global/Picture/Picture';
import { trackEvent } from 'helpers/Analytics';
import { Image } from 'interfaces/image';
import { IZipGateLabels } from 'interfaces/zipgate';
import React, { useEffect, useState } from 'react';
import ModalContainer from '../ModalContainer/ModalContainer';
import ZipGate from 'components/Global/ZipGate/ZipGate';
import './ZipGateModal.scss';
import { getZipcode } from 'helpers/Zipgate';

export interface IZipgateModalProps {
  isOpen?: boolean;
  labels: IZipGateLabels;
  mapBackground?: Image;
  isContained?: boolean;
  isLocator?: boolean;
}

const ZipGateModal = ({
  isOpen,
  labels,
  mapBackground,
  isContained,
  isLocator,
}: IZipgateModalProps): JSX.Element => {
  const [pageHeading, setPageHeading] = useState('');
  const [zipType, setZipType] = useState('');
  const [hideCloseButton, setHideCloseButton] = useState(false);
  const [showBackground, setShowBackground] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const isHonda = process.env.REACT_APP_THEME === 'honda';

  useEffect(() => {
    const handleModalEvent = (e: CustomEventInit) => {
      setHideCloseButton(e.detail?.hideCloseButton);
      setShowBackground(e.detail?.showBackground);
      setPageHeading(e.detail?.pageHeading || '');
      setZipType(e.detail?.source || '');
      setShowModal(true);
    };
    window.addEventListener('react-zipgate-open', handleModalEvent);
    return () => {
      window.removeEventListener('react-zipgate-open', handleModalEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseModal = () => {
    showBackground && setShowBackground(false);
    if (!isHonda) {
      if (isLocator) {
        setShowModal(false);
      } else {
        trackEvent({
          label: `location access:close modal`,
          category: {
            text: 'user location access modal',
            includePageName: false,
          },
          locator: {
            User: {
              user_zipcode: getZipcode(),
            },
          },
        });
        setShowModal(false);
      }
    } else {
      setShowModal(false);
    }
  };

  return (
    <div className="zipgate-modal">
      {showBackground && mapBackground && (
        <Picture
          image={mapBackground}
          classNames={{
            container: isContained
              ? 'zipgate-modal__contained-background new'
              : 'zipgate-modal__background new',
            img: 'zipgate-modal__background-image new',
          }}
          isDecorative
        />
      )}
      {(isOpen || showModal) && isContained ? (
        <div className="zipgate-modal__contained-shadow">
          <div className={`zipgate-modal__contained-zipgate t-zipgate-modal`}>
            <ZipGate
              labels={labels}
              pageHeading={pageHeading}
              zipType={zipType}
              closeFunction={handleCloseModal}
              isLocator={isLocator}
            />
          </div>
        </div>
      ) : (
        <ModalContainer
          closeFunction={handleCloseModal}
          isOpen={isOpen || showModal}
          title={'Zipgate Modal'}
          className={`zipgate-modal__container t-zipgate-modal`}
          hideClosingButton={hideCloseButton}
          customZIndex={99}
          noTracking
        >
          <ZipGate
            labels={labels}
            pageHeading={pageHeading}
            zipType={zipType}
            closeFunction={handleCloseModal}
            isLocator={isLocator}
          />
        </ModalContainer>
      )}
    </div>
  );
};

export default ZipGateModal;
